import React from 'react';

export const PricingCoinSkeleton: React.FC = () => {
  return (
    <div className="p-3 sm:p-4 md:p-6">
      <style>{`
        @keyframes shimmer {
          0%   { background-position: -700px 0; }
          100% { background-position:  700px 0; }
        }

        .sk {
          background: linear-gradient(
            90deg,
            #ddd6fe 25%,
            #c4b5fd 50%,
            #ddd6fe 75%
          );
          background-size: 700px 100%;
          animation: shimmer 1.5s infinite linear;
          border-radius: 6px;
        }

        .grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 20px;
          max-width: 1040px;
        }

        @media (max-width: 640px) {
          .grid {
            grid-template-columns: 1fr;
            gap: 16px;
          }

          .card {
            border-radius: 12px;
          }

          .card-body {
            padding: 14px 14px 12px 14px;
          }

          .card-footer {
            padding: 12px 14px;
          }

          .sk-icon {
            width: 70px;
            height: 70px;
          }

          .sk-title {
            width: 50px;
            height: 20px;
          }

          .sk-badge {
            width: 65px;
            height: 20px;
          }

          .sk-sub {
            width: 110px;
            height: 12px;
          }

          .sk-btn {
            width: 80px;
            height: 32px;
          }
        }

        @media (min-width: 641px) and (max-width: 1024px) {
          .grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 18px;
          }

          .card {
            border-radius: 13px;
          }

          .card-body {
            padding: 16px 16px 13px 16px;
          }

          .card-footer {
            padding: 13px 16px;
          }

          .sk-icon {
            width: 80px;
            height: 80px;
          }

          .sk-btn {
            width: 90px;
            height: 34px;
          }
        }

        @media (min-width: 1025px) {
          .grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
          }
        }

        .card {
          background: #ede9fe;
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 2px 12px rgba(124,58,237,.08);
          display: flex;
          flex-direction: column;
        }

        .card-body {
          padding: 18px 18px 14px 18px;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          flex: 1;
        }

        .card-info {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .card-footer {
          background: #e8e3ff;
          padding: 14px 18px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .sk-title {
          width: 60px;
          height: 22px;
        }

        .sk-badge {
          width: 76px;
          height: 22px;
          border-radius: 20px;
          margin-left: 8px;
        }

        .sk-sub {
          width: 130px;
          height: 14px;
          margin-top: 4px;
        }

        .sk-icon {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .sk-price {
          width: 64px;
          height: 28px;
        }

        .sk-btn {
          width: 100px;
          height: 36px;
          border-radius: 8px;
        }

        .title-row {
          display: flex;
          align-items: center;
        }
      `}</style>

      <div className="grid">
        {[...Array(3)].map((_, index) => (
          <div key={index} className="card" style={{ animationDelay: `${index * 0.1}s` }}>
            <div className="card-body">
              <div className="card-info">
                <div className="title-row">
                  <div className="sk sk-title"></div>
                  <div className="sk sk-badge"></div>
                </div>
                <div className="sk sk-sub"></div>
              </div>
              <div className="sk sk-icon"></div>
            </div>
            <div className="card-footer">
              <div className="sk sk-price"></div>
              <div className="sk sk-btn"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
